export const ConsumirRegistro = "ConsumirRegistro";
export const ConsumirLogin = "ConsumirLogin";
export const ConsumirCerrarSession = "ConsumirCerrarSession";
export const ConsumirCambioClave = "ConsumirCambioClave";
export const ActualizarCliente = "ActualizarCliente";
export const Cargando = "LOGIN_CARGANDO";
export const Error = "LOGIN_ERROR";
